import React from 'react';

/**
 * TrowFragment is a button displaying its props.date
 *  marked up with a div of "trow" class.
 *
 * @reactProps {string} date - can be any string to display in the div
 * @reactProps {function} onEvent - a function, something for the button to do onClick
 */
export default class TrowFragment extends React.Component {
  /**
   * onClick, the button will pass this.props.date to this.props.onEvent
   */
  onEvent = () => {
    this.props.onEvent(this.props.date);
  };

  /**
   * Render a button inside a div of class "trow"
   * @return div > button
   */
  render() {
    return (
      <div className="trow">
        <button onClick={this.onEvent}>{this.props.date}</button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/TrowFragment.js